export const TestIds = {
  item: 'gallery-item-item',
  panel: 'gallery-item-panel',
  title: 'gallery-item-title',
  description: 'gallery-item-description',
  link: 'gallery-item-link',
  imageZoomBtn: 'gallery-item-image-zoom-button',
  disabledClickActionWrapper: 'gallery-item-disabled-click-action-wrapper',
} as const;

export const translations = {
  ARIA_LABEL_NAMESPACE: 'ariaLabels',
  IMAGE_ZOOM_ARIA_LABEL_KEY: 'GalleryItem_AriaLabel_ZoomImageButton',
  IMAGE_ZOOM_ARIA_LABEL_DEFAULT: 'press to zoom',
};
